// 公共管理
import axios from './request'


// // 商品列表
export const goodsCommonGet = (params) =>
  axios({
    url: '/v1/front/good',
    method: 'get',
    params
  })

// 商品列表 详情
export const goodsCommonIdGet = (params) =>
  axios({
    url: `/v1/front/good/${params}`,
    method: 'get',
  })


// 评论列表接口（GET）
export const goodsFrontEvaluateGet = (params) =>
  axios({
    url: '/v1/front/evaluate/shop',
    method: 'get',
    params
  })


// 联系我们
export const goodsContactPost = (data) =>
  axios({
    url: `/v1/front/contact`,
    method: 'post',
    data
  })

// 商品列表 删除接口（DELETE/POST，根据后端实际调整）
export const goodsClassifyGood = (params) =>
  axios({
    url: `/v1/front/classify/good`,
    method: 'get',
    params
  })




// // 删除评论接口（DELETE/POST，根据后端实际调整）
// export const goodsManagerEvaluateIdDelete = (params) =>
//   axios({
//     url: `/v1/manager/evaluate/${params}`,
//     method: 'delete',
//   })



// // 评论评价
// export const goodsManagerEvaluatePost = (data) =>
//   axios({
//     url: `/v1/manager/evaluate`,
//     method: 'post',
//     data
//   })